import _extends from "@babel/runtime/helpers/extends";
import React, { Suspense } from 'react';
import { TimeLazyLoad } from '../../../common/lazy-load-timing';
import { LoadingSpinner } from '../../../common/loading-spinner';
var ConfluenceComponent = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/async/confluence-dialog" */'./confluence-search-dialog').then(function (_ref) {
    var ConfluenceSearchDialogWithQueryContext = _ref.ConfluenceSearchDialogWithQueryContext;
    return {
      default: ConfluenceSearchDialogWithQueryContext
    };
  });
});
export var ConfluenceAsyncWrapper = function ConfluenceAsyncWrapper(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(TimeLazyLoad, {
      product: "confluence"
    }, /*#__PURE__*/React.createElement(LoadingSpinner, null))
  }, /*#__PURE__*/React.createElement(ConfluenceComponent, _extends({}, props, {
    debounceTime: 250
  })));
};